import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { DetailService } from '../services/detail.service';
import { TokenManager } from '../Globals';

@Component({
  selector: 'app-layout-detail',
  templateUrl: './layout-detail.component.html',
  styleUrls: ['./layout-detail.component.css']
})
export class LayoutDetailComponent implements OnInit {

  private documentType:string;
  private documentId:string;
  componentId:string;
  constructor(private route:ActivatedRoute, private globals:Globals, private router:Router, 
    private detailService:DetailService,
    private tokenManager:TokenManager) {
      this.router.events.subscribe((e: any)=>{
        this.componentId = this.route.snapshot.paramMap.get('id');
      })
     }

  ngOnInit() {
    var self = this;
    this.tokenManager.store("BRNCurrentRoute", this.router.url);
    if(this.globals.Session == null){self.router.navigate(['/', '/']) };

    this.componentId = this.route.snapshot.paramMap.get('id');

  }
}
